<template>
  <crm-side-panel @handleClose="handleCloseDetail" :title="detail.projectName">
    <div class="side-panel-content compact-detail-content">
      <div class="side-panel-buttons">
        <crm-button
          v-if="auth.updateProject && auth.updateProject.toggleStatus"
          :size="'mini'"
          :text="'编辑'"
          @click="handleUpdate()"
        >
        </crm-button>
        <crm-button
          v-if="auth.deleteProject && auth.deleteProject.toggleStatus"
          :size="'mini'"
          :buttonType="'danger'"
          :text="'删除'"
          @click="handleDelete()"
        >
        </crm-button>
      </div>
      <div class="side-panel-header">
        <!-- 合同信息 -->
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">客户名称</p>
            <p class="info-detail">{{ detail.customerName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">sourceid</p>
            <p class="info-detail">{{ detail.projectSourceId }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">上线日期</p>
            <p class="info-detail">{{ detail.projectDetailVO.onlineDate }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员</p>
            <p class="info-detail">{{ detail.salesmanName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员所属部门</p>
            <p class="info-detail">{{ detail.teamName }}</p>
          </div>
        </div>
      </div>

      <!-- 项目详情各tab项 -->
      <div class="side-panel-tabs">
        <el-tabs v-model="activeTab" @tab-click="handleClick" :stretch="false">
          <!-- 项目信息tab页 -->
          <el-tab-pane label="详细信息" name="projectInfo" v-loading="loading">
            <pane-info :detail="detail"></pane-info>
          </el-tab-pane>

          <!-- 套餐内容tab页 -->
          <el-tab-pane
            label="套餐内容"
            name="package"
            v-if="auth.projectPackageTab && auth.projectPackageTab.toggleStatus"
          >
            <el-table
              :data="projectPackage"
              v-loading="packageLoading"
              :span-method="objectSpanMethod"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column
                prop="packageName"
                label="套餐名称"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="gmtCreatedStr"
                label="套餐创建时间"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="packageCode"
                label="套餐编号"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="serviceName"
                label="服务名称"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="totalCount" label="总次数" align="center">
              </el-table-column>
              <el-table-column
                prop="selfUse"
                label="是否限制本人"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="discount" label="折扣率" align="center">
              </el-table-column>
              <el-table-column
                prop="waitDay"
                label="等待期"
                width="180"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <!-- <div class="info-wrap">
                <span class="info-title">开票总金额：</span>
                <span class="info-detail">{{compactDetail.invoiceAmount}}元</span>
                <span class="info-title">回款总金额：</span>
                <span class="info-detail">{{compactDetail.refundAmount}}元</span>
              </div> -->
              <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="packageList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="packageList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="projectPackage.totalCount">
              </el-pagination> -->
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 编辑项目弹窗 -->
    <div v-if="addProjectDialogVisible">
      <add-project
        :mode="mode"
        :id="detailId"
        :detail="addProjectDialogObj"
        @close="handleCloseAddDialog"
        @success="handleRefresh"
      >
      </add-project>
    </div>
  </crm-side-panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmSidePanel from '~component/base/crmSidePanel.vue';
import CrmButton from '@/components/base/crmButton';
import PaneInfo from './paneInfo.vue';
import AddProject from '~component/business/project/addProject.vue';

export default {
  components: {
    CrmSidePanel,
    CrmButton,
    PaneInfo,
    AddProject,
  },
  props: {
    detailId: String,
    detailTabName: String,
  },
  data() {
    return {
      loading: false,
      detail: {
        projectDetailVO: {},
      },
      isRefresh: false,
      activeTab: 'projectInfo',
      packageLoading: false,
      packageList: {
        pageNumber: 1,
        pageSize: 5,
      },
      addProjectDialogVisible: false,
      mode: 'add',
      addProjectDialogObj: undefined,
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      projectPackage: 'project/projectPackage',
    }),
  },
  watch: {
    detailId(val) {
      if (val) {
        this.handleQueryDetail();
        this.isRefresh = false;
        this.activeTab = 'projectInfo';
      }
    },
  },
  methods: {
    ...mapActions({
      getProjectDetail: 'project/getProjectDetail',
      deleteProject: 'project/deleteProject',
      getProjectPackage: 'project/getProjectPackage',
    }),
    objectSpanMethod({
      row, column, rowIndex, columnIndex, 
    }) {
      if (columnIndex < 3) {
        if (row.isNewProject) {
          return {
            rowspan: row.len,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }

      return {
        rowspan: 1,
        colspan: 1,
      };
    },
    handleQueryDetail() {
      this.loading = true;
      this.getProjectDetail({ id: this.detailId })
        .then((res) => {
          this.detail = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCloseDetail() {
      this.$emit('handleCloseDetail', this.isRefresh);
    },
    handleStopHideDialog(events) {
      events.stopPropagation();
    },
    // 编辑
    handleUpdate() {
      this.addProjectDialogVisible = true;
      this.mode = 'update';
      this.addProjectDialogObj = this.detail;
    },
    handleCloseAddDialog() {
      this.addProjectDialogVisible = false;
    },
    handleRefresh() {
      this.isRefresh = true;
      this.addProjectDialogVisible = false;
      this.handleQueryDetail();
    },
    handleDelete() {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteProject({ id: this.detailId }).then(() => {
            this.isRefresh = true;
            this.handleCloseDetail();
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          });
        })
        .catch(() => {});
    },
    // tab 切换
    handleClick() {
      this.handleGetTabData();
    },
    handleCurrentChange(val) {
      this.package.pageNumber = val;
      this.handleGetPackage();
    },
    handleGetTabData() {
      switch (this.activeTab) {
        case 'projectInfo':
          // this.getCompactDetail({ id: this.detailId });
          break;
        case 'package':
          this.handleGetPackage();
          break;
        default:
          break;
      }
    },
    handleGetPackage() {
      const params = {
        id: this.detailId,
      };
      this.getProjectPackage(params);
    },
    handleGetCostList() {
      this.costLoading = true;
      const { pageSize, pageNumber } = this.cost;
      this.getCompactCostList({
        contractId: this.detailId,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.compactCostData.results.length === 0 && pageNumber !== 1) {
          this.cost.pageNumber = 1;
          this.handleGetCostList();
        } else {
          this.costLoading = false;
        }
      });
    },
    handleGetPayList() {
      this.addPayDialog.payLoading = true;
      const { pageSize, pageNumber } = this.pay;
      this.getPayDataList({
        contractId: this.detailId,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.payDataList.results.length === 0 && pageNumber !== 1) {
          this.pay.pageNumber = 1;
          this.handleGetPayList();
        } else {
          this.addPayDialog.payLoading = false;
        }
      });
    },
    handleSizeChange(val) {
      this[this.activeTab].pageSize = val;
      this[this.activeTab].pageNumber = 1;

      this.handleGetPackage();
    },
  },
};
</script>

<style lang="less">
.compact-detail-content {
  ::-webkit-scrollbar-track-piece {
    display: none;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
.busi-dialog {
  padding: 0 30px;
  .el-form-item__label {
    float: none;
  }
}
.dialog-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}
.returnd-money-wrap {
  width: 100%;
  border-top: 1px dashed #cccccc;
  .returnd-money-title {
    width: 60px;
    background-color: #ffffff;
    margin-top: -12px;
  }
  .icon-delete {
    cursor: pointer;
    text-align: center;
    font-size: 20px;
    margin-left: -130px;
    color: #f56c6c;
  }
}
.date-add-return {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }
}
</style>
